import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faFileWord from '@fortawesome/fontawesome-free-solid/faFileWord'


class PressReleases extends Component {
  render() {
    return (
      <div>
        <a href="/Aug1.docx">August Release <FontAwesomeIcon icon={faFileWord} size="2x"/></a>
      </div>
    );
  }
}

export default PressReleases;



// WEBPACK FOOTER //
// ./src/components/PressReleases.js